import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setActiveHeaderTab } from "../../../../redux/headerTabsSlice";
import useClickOutside from "../../../../CustomHooks/useClickOutside";
import { VISIT_HISTORY } from "../../../../api/allApi_List";
import useGetHistory from "../../../../CustomHooks/useAxios/useGetHistory";
import CustomDateSelector from "./CustomDateSelector";

const historyOptions = [
  { title: "Last 30 Days", monthsAgo: 1 },
  { title: "Last 3 Month", monthsAgo: 3 },
  { title: "Last 6 Month", monthsAgo: 6 },
  { title: "Custom Date" },
];

const getDateBefore = (months) => {
  const d = new Date();
  d.setMonth(d.getMonth() - months);
  return d.toISOString().split("T")[0];
};

const VisitHistoryFIlter = () => {
  const [showTabsMenu, setShowTabsMenu] = useState(false);
  const { dropdownRef } = useClickOutside(() => setShowTabsMenu(false));
  const activeHeaderTab = useSelector(
    (state) => state.activeHeaderTab.activeHeaderTab,
  );

  const { getHistory, historyLoaded } = useGetHistory();
  const [customDates, setCustomDates] = useState({
    start: "",
    end: "",
  });
  const dispatch = useDispatch();

  const getOptionStyle = (title) => {
    return `border-b p-1 max-lg:text-xs cursor-pointer hover:bg-lb3 transition-all ease-in-out duration-30 ${
      activeHeaderTab === title ? "bg-lb3" : ""
    }`;
  };

  const getDropdownStyle = `absolute shadow-sh-2 z-9999 border-1 bg-white ${
    activeHeaderTab === "Custom Date" ? "w-72" : "w-44"
  }`;

  const fetchHistory = (title, monthsAgo) => {
    monthsAgo && setShowTabsMenu(false);
    if (activeHeaderTab !== title) {
      dispatch(setActiveHeaderTab(title));
      if (monthsAgo) {
        setCustomDates({
          start: "",
          end: "",
        });
        const today = new Date().toISOString().split("T")[0];
        const fromDate = getDateBefore(monthsAgo);
        getHistory(`${VISIT_HISTORY}${fromDate}/${today}`);
      }
    }
  };

  useEffect(() => {
    dispatch(setActiveHeaderTab("Last 30 days"));
  }, []);

  return (
    <div className="flex items-center">
      <div className="block relative" ref={dropdownRef}>
        <button
          className="border-b-2 border-dark-blue pr-5 max-lg:text-sm"
          onClick={() => setShowTabsMenu((prev) => !prev)}
        >
          {activeHeaderTab}
          <span
            className={`DropdownBlueArrow ${
              showTabsMenu ? "rotate-90" : "rotate-90n"
            }`}
          >{`<`}</span>
        </button>
        {showTabsMenu && (
          <ul className={getDropdownStyle}>
            {historyOptions.map((item, ind) => {
              return (
                <li
                  key={ind}
                  className={getOptionStyle(item.title)}
                  onClick={() => fetchHistory(item.title, item.monthsAgo)}
                >
                  {item.title}
                </li>
              );
            })}
            {activeHeaderTab === "Custom Date" && (
              <CustomDateSelector
                historyLoaded={historyLoaded}
                getHistory={getHistory}
                closeDropDown={() => setShowTabsMenu(false)}
                customDates={customDates}
                setCustomDates={setCustomDates}
              />
            )}
          </ul>
        )}
      </div>
      {historyLoaded && (
        <p className="text-blue-500 text-sm pl-3">Loading...</p>
      )}
    </div>
  );
};
export default VisitHistoryFIlter;
